import { render } from "./Toolbar.vue?vue&type=template&id=4b8176a4"
import script from "./Toolbar.vue?vue&type=script&lang=js"
export * from "./Toolbar.vue?vue&type=script&lang=js"

import "./Toolbar.vue?vue&type=style&index=0&id=4b8176a4&lang=css"
script.render = render

export default script